import React from 'react';
import { Box } from '@mui/material';

const PageContainer = ({ children, sx = {}, ...props }) => {
  return (
    <Box
      sx={{
        maxWidth: '1280px',
        mx: 'auto',
        px: { xs: 2, sm: 3, md: 4 },
        width: '100%',
        ...sx
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default PageContainer; 